
import { v4 as uuidv4 } from "uuid";
import { FeatureUserRating } from "@models";
import { CreatureLimitation } from "@dndModels/misc";

export class TransformOption {
  true_id = "";
  transform_id = "";
  creature_limit: CreatureLimitation = new CreatureLimitation();
  
  constructor(obj?: any) {
    this.true_id = obj ? obj.true_id : uuidv4().toString();
    if (obj) {
      this.transform_id = obj.transform_id ? obj.transform_id : "";
      this.creature_limit = obj.creature_limit ? new CreatureLimitation(obj.creature_limit) : new CreatureLimitation();
    }
  }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      transform_id: this.transform_id,
      creature_limit: this.creature_limit.toDBObj(),
    };
  }

  clone(drop_ids = false): TransformOption {
    const new_obj = new TransformOption();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copy(copyMe: TransformOption, drop_ids = false): void {
    if (!drop_ids) {
      this.true_id = copyMe.true_id;
    }
    this.transform_id = copyMe.transform_id;
    this.creature_limit = copyMe.creature_limit.clone();
  }

  connectUserRatings(userRatings: FeatureUserRating[]) {
  }
}

// export class AdaptationOption {
//   true_id: string = "";
//   adaptation_id: string = "";
//   creature_ids: string[] = [];
  
//   constructor(obj?: any) {
//     this.true_id = obj ? obj.true_id : uuidv4().toString();
//     if (obj) {
//       this.adaptation_id = obj.adaptation_id ? obj.adaptation_id : "";
//       this.creature_ids = obj.creature_ids ? obj.creature_ids : [];
//     }
//   }

//   toDBObj(): any {
//     return {
//       true_id: this.true_id,
//       adaptation_id: this.adaptation_id,
//       creature_ids: this.creature_ids,
//     };
//   }

//   clone(drop_ids: boolean = false): AdaptationOption {
//     const new_obj = new AdaptationOption();
//     new_obj.copy(this, drop_ids);
//     return new_obj;
//   }

//   copy(copyMe: AdaptationOption, drop_ids: boolean = false): void {
//     if (!drop_ids) {
//       this.true_id = copyMe.true_id;
//     }
//     this.adaptation_id = copyMe.adaptation_id;
//     this.creature_ids = [...copyMe.creature_ids];
//   }

//   connectUserRatings(userRatings: FeatureUserRating[]) {
//   }
// }